export default __webpack_public_path__ + "locales/sq-AL/ChangePortalOwner.json?hash=dc1ecec835f9b9487af279f64bce1344";